// SymbolControlAccordion — lifted verbatim out of LiveTrading.tsx (God 2026-08-26).
// Same code, smaller address: a UI problem in this panel is now a 19-line file
// to read instead of a 6,900-line one. Imports are derived from what the block
// actually references, not guessed.

import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { SymbolControlStrip } from './SymbolControlStrip';

export const SymbolControlAccordion: React.FC = () => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{margin:'0 2px 8px',border:'1px solid #1a2138',borderRadius:9,background:'#0b0f1a',overflow:'hidden'}}>
      <button onClick={() => setOpen(o => !o)}
        style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'space-between',gap:8,
          padding:'9px 12px',background:'transparent',border:'none',cursor:'pointer'}}>
        <span style={{display:'flex',alignItems:'center',gap:8,minWidth:0}}>
          <span style={{fontSize:12}}>🎛️</span>
          <span style={{fontSize:10,fontWeight:800,color:'#94a3b8',letterSpacing:1}}>SYMBOL CONTROL (L0)</span>
          <span style={{fontSize:8,color:'#64748b',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>surgical per-symbol kill · entries only</span>
        </span>
        <span style={{fontSize:9,color:'#64748b',transform:open?'rotate(90deg)':'none',transition:'transform .18s ease',flexShrink:0}}>▶</span>
      </button>
      {open && <SymbolControlStrip/>}
    </div>
  );
};

